import {
    URLAPI,
    DETAIL_PURCHASE_CREATE_PATH,
    DETAIL_PURCHASE_UPDATE_PATH,
    DETAIL_PURCHASE_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_detail_purchase: {
        data: {},
        status: 0,
        message: {},
    },
    _update_detail_purchase: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_detail_purchase: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_DETAIL_PURCHASE = "CREATE_DETAIL_PURCHASE";
export const UPDATE_DETAIL_PURCHASE = "UPDATE_DETAIL_PURCHASE";
export const DELETE_DETAIL_PURCHASE = "DELETE_DETAIL_PURCHASE";

export const detail_purchase_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_DETAIL_PURCHASE:
            return {
                ...state,
                _create_detail_purchase: action.payload,
            };
        case UPDATE_DETAIL_PURCHASE:
            return {
                ...state,
                _update_detail_purchase: action.payload,
            };
        case DELETE_DETAIL_PURCHASE:
            return {
                ...state,
                _delete_detail_purchase: action.payload,
            };

        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const createDetailPurchase = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${DETAIL_PURCHASE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_DETAIL_PURCHASE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_DETAIL_PURCHASE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_DETAIL_PURCHASE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateDetailPurchase = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${DETAIL_PURCHASE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_DETAIL_PURCHASE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_DETAIL_PURCHASE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_DETAIL_PURCHASE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteDetailPurchase = (token, id, id_reason) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${DETAIL_PURCHASE_DELETE_PATH}${id}/${id_reason}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_DETAIL_PURCHASE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: DELETE_DETAIL_PURCHASE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_DETAIL_PURCHASE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_detail_purchase = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
